import React from "react";
import GridColumn from "./GridColumn";
import { ArrayKeys } from "../../foundation/ArrayKeys";

interface GridGroupingProps<T, U> {
    value: ArrayKeys<T, U>;
    
    children?:
        | React.ReactElement<GridColumn<T>>
        | React.ReactElement<GridColumn<T>>[];
}

class GridGrouping<T, U> extends React.Component<GridGroupingProps<T, U>> {
    value: ArrayKeys<T, U>;
    
    children?:
        | React.ReactElement<GridColumn<T>>
        | React.ReactElement<GridColumn<T>>[];

    render(): React.ReactNode {
        return null;
    }
}

export default GridGrouping;
